export interface PopoverPlacement {
  align?: 'start' | 'end'
  placement?: 'below' | 'above'
  clamp?: boolean
  matchWidth?: boolean
}

export function placePopover(
  pop: HTMLElement,
  trigger: HTMLElement,
  { align = 'end', placement = 'below', clamp = false, matchWidth = false }: PopoverPlacement = {},
): void {
  const rect = trigger.getBoundingClientRect()
  const viewportHeight = document.documentElement.clientHeight
  const below = viewportHeight - rect.bottom - 14
  const above = rect.top - 14
  const flip = clamp && placement === 'below' && below < 320 && above > below
  if (placement === 'above' || flip) {
    pop.style.top = 'auto'
    pop.style.bottom = `${Math.max(8, viewportHeight - rect.top + 6)}px`
    if (clamp) pop.style.maxHeight = `${Math.max(160, rect.top - 6 - 8)}px`
  } else {
    pop.style.bottom = 'auto'
    const top = rect.bottom + 6
    pop.style.top = `${top}px`
    if (clamp) pop.style.maxHeight = `${Math.max(160, viewportHeight - top - 8)}px`
  }
  if (matchWidth) pop.style.minWidth = `${rect.width}px`

  if (align === 'start') {
    pop.style.right = 'auto'
    pop.style.left = `${rect.left}px`
  } else {
    pop.style.left = 'auto'
    pop.style.right = `${Math.max(8, document.documentElement.clientWidth - rect.right)}px`
  }
}

export function keepInsideViewport(pop: HTMLElement): void {
  const { left, right } = pop.getBoundingClientRect()
  const viewportWidth = document.documentElement.clientWidth
  if (left < 8) {
    pop.style.right = 'auto'
    pop.style.left = '8px'
  } else if (right > viewportWidth - 8) {
    pop.style.left = 'auto'
    pop.style.right = '8px'
  }
}

export function popoverTrigger(pop: HTMLElement): HTMLElement | null {
  return document.querySelector<HTMLElement>(`[popovertarget="${pop.id}"]`)
}

export function closePopovers(): void {
  for (const pop of document.querySelectorAll<HTMLElement>('[popover]:popover-open')) {
    pop.hidePopover()
    popoverTrigger(pop)?.setAttribute('aria-expanded', 'false')
  }
}
